"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiBankAccountResponseDto = void 0;
const billing_core_external_account_purpose_enum_1 = require("../../../../billing-core/billing-core-account/types/enums/billing-core-external-account-purpose.enum");
const swagger_1 = require("../../../../swagger-fake");
const class_validator_1 = require("class-validator");
const billing_api_fn_1 = require("../../../../billing-api/shared/billing-api-fn");
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const billing_api_contractor_response_dto_1 = require("../../../billing-api-contractor/types/dtos/billing-api-contractor-response.dto");
const billing_api_pointer_dto_1 = require("../../../shared/types/dto/billing-api-pointer.dto");
const billing_api_account_response_dto_1 = require("./billing-api-account-response.dto");
const class_transformer_1 = require("class-transformer");
//@ApiExtraModels(BillingApiCardAccountResponseDto)
let BillingApiBankAccountResponseDto = class BillingApiBankAccountResponseDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id контрагента чьи реквизиты",
  format: "uuid"
}), (0, class_validator_1.IsUUID)(4), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiBankAccountResponseDto.prototype, "contractorId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id счёта к которому относятся банковские реквизиты",
  format: "uuid"
}), (0, class_validator_1.IsUUID)(4), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiBankAccountResponseDto.prototype, "accountId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Последние 4 цифры счёта",
  example: "3000"
}), (0, class_validator_1.IsString)(), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiBankAccountResponseDto.prototype, "label", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Банк (опционально)",
  example: "STRIPE TEST BANK"
}), (0, class_validator_1.IsString)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiBankAccountResponseDto.prototype, "brand", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Номер маршрутизации (опционально) (например, SWIFT CODE это номер маршрутизации)",
  example: "INJSAM22XXX"
}), (0, class_validator_1.IsString)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiBankAccountResponseDto.prototype, "routingNumber", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата создания",
  format: "date-time"
}), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Date)], BillingApiBankAccountResponseDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата обновления",
  format: "date-time"
}), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Date)], BillingApiBankAccountResponseDto.prototype, "updatedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Контрагент (доступно при использовании include-опций запроса)",
  type: () => billing_api_pointer_dto_1.BillingApiPointerDto
}), (0, class_transformer_1.Expose)(), __metadata("design:type", billing_api_contractor_response_dto_1.BillingApiContractorResponseDto)], BillingApiBankAccountResponseDto.prototype, "contractor", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Счёт (доступно при использовании include-опций запроса)",
  ...(0, billing_api_fn_1.swaggerRef)("BillingApiAccountResponseDto")
}), (0, class_transformer_1.Expose)(), __metadata("design:type", billing_api_account_response_dto_1.BillingApiAccountResponseDto)], BillingApiBankAccountResponseDto.prototype, "account", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Назначение (оплата, выплата, оплата-выплата)",
  enum: billing_core_external_account_purpose_enum_1.BillingCoreExternalAccountPurposeEnum
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsEnum)(billing_core_external_account_purpose_enum_1.BillingCoreExternalAccountPurposeEnum), __metadata("design:type", String)], BillingApiBankAccountResponseDto.prototype, "purpose", void 0);
BillingApiBankAccountResponseDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiBankAccountResponseDto);
exports.BillingApiBankAccountResponseDto = BillingApiBankAccountResponseDto;
